import React, { Component } from 'react';

class BreadCrumb extends React.Component {

    render() {
        var breadCrumbArray = [];
        var childArray = [];
        var data = Object.values(this.props.menuOptions);
        if (this.props.pathname == '/') {
            breadCrumbArray.push(<li className="breadcrumb-item active" key={`breadcrumb_${i}`}>{data[0]['label']}</li>);
        }

        if (this.props.pathname == '/admin/logs' || this.props.pathname == '/admin/raw_data') {
            let params = (new URL(document.location)).searchParams;
            let tableName = '';
            let parent_breadcrumb_name = '';
            if (this.props.pathname == '/admin/logs') {
                tableName = params.get('tableName');
                parent_breadcrumb_name = `Logs`;
            }
            if (this.props.pathname == '/admin/raw_data') {
                tableName = params.get('raw_data');
                parent_breadcrumb_name = `Raw Table`;
            }

            breadCrumbArray.push(<li className="breadcrumb-item" key={`breadcrumb_${parent_breadcrumb_name}`}>{parent_breadcrumb_name}</li>);
            breadCrumbArray.push(<li className="breadcrumb-item active" key={`breadcrumb_${tableName}`}>{tableName}</li>);
        }
        for (var i = 0; i < data.length; i++) {
            if (data[i].children !== null && data[i].children !== undefined) {
                var childrens = data[i].children;
                childArray = Object.values(childrens).filter((element, i) => {
                    let link = element.link;
                    if (link.indexOf("?") !== -1) {
                        link = element.link.slice(0, element.link.indexOf("?"));
                    }
                    return link == location.pathname;
                });

                if (childArray.length !== 0) {
                    breadCrumbArray.push(<li className="breadcrumb-item" key={`breadcrumb_${i}`}>{data[i]['label']}</li>);
                    breadCrumbArray.push(<li className="breadcrumb-item active" key={`breadcrumb_${i}_0`}>{childArray[0]['label']}</li>);
                }
            }
            else if (this.props.pathname == data[i].link) {
                breadCrumbArray.push(<li className="breadcrumb-item active" key={`breadcrumb_${i}`}>{data[i]['label']}</li>);
            }
        }
        return (
            <div className="mb-2">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-style2 mg-b-0">
                        <li className="breadcrumb-item" key={`breadcrumb_0`}>Admin Panel</li>
                        {breadCrumbArray}
                    </ol>
                </nav>
            </div>
        )
    }
}

export default BreadCrumb;